import React from 'react';
import styles from '../../../assets/css/layoutMain/providers/providers.module.css';
import images from '../../../assets/images';
const Providers = () => {
    return (
        <div className={styles.cardProviders}>
            <section className={styles.provider}>
                <div className={styles.provider__title}>
                    <img src={images.recurso6green} alt="icon" />
                    <h4 src={images.h4}>Providers</h4>
                </div>
                <div className={styles.provider__content}>
                    <div>
                        <a href="#!">
                            <strong>3</strong>Followers
                        </a>
                    </div>

                    <div>
                        <a href="#!">
                            <strong>5</strong>Following
                        </a>
                    </div>

                    <div className={styles.provider__content_box}>
                        <img src={images.recurso17gray} alt="" />
                        <a
                            className={`${styles.provider__content}  ${styles.active}`}
                            href="#!">
                            Explore Providers
                        </a>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Providers;
